var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iv-main-width"},[_c('Tab',{staticClass:"iv-home-list",attrs:{"value":_vm.value,"navList":_vm.navList},on:{"on-click":_vm.tabClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }